import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { applyRegion, environment } from "src/environments/environment";

@Component({
  selector: 'app-text-summary',
  templateUrl: './text-summary.component.html',
  styleUrls: ['./text-summary.component.css']
})
export class TextSummaryComponent implements OnInit {
  providerInfoForm: FormGroup
  tokenHasError = [false, '']
  hasErrorProcessing = [false, '']
  isProcessingText = false
  showResults = false
  summary = 'Resumen de ejemplo'

  constructor(private http: HttpClient, protected $gaService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.providerInfoForm = new FormGroup({
      ptext: new FormControl("", [Validators.required]),
      ptoken_compai: new FormControl("", [Validators.required]),
      psentence_count: new FormControl("", [Validators.required]),
    });
    this.$gaService.pageView("/", "Text summarizer");
  }

  async summarize() {
    this.$gaService.event("summarize_text");

    this.isProcessingText = true
    this.showResults = false

    const values = this.providerInfoForm.value
    this.hasErrorProcessing = [false, '']
    try {
      const response: any = await this.callSummaryEndpoint(values.ptext, values.psentence_count, values.ptoken_compai);
      this.summary = response.outputs.data[0].result
      this.showResults = true
    } catch (error) {
      this.hasErrorProcessing = [true, 'Error durante la extracción del resumen.']
    }
    this.isProcessingText = false
  }

  private async callSummaryEndpoint(text: string, sentCount: number, token: string) {
    const body = {
      token,
      inputs: {
        text,
        num_sentences: sentCount
      }
    };
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    const endpointUrl = environment.apiUrl + 'model/summary-mobilebert-uncased'

    const urls = []
    urls.push(environment.heroku + 'api/model/summary-mobilebert-uncased')
    urls.push(applyRegion(endpointUrl, environment.renderRegions.oregon))
    urls.push(applyRegion(endpointUrl, environment.renderRegions.frankfurt))

    for (const link of urls) {
      try {
        return await this.http.post(link, body, httpOptions).pipe().toPromise();
      } catch (error) {
        continue
      }
    }
    return undefined
  }
}
